import HtmlContentDiv from '@/components/html-div';
import { getStyle } from '@/utils/theme/fonts';
import { getColor } from '@/utils/theme/colors';
getColor;
import { Box } from '@mui/material';
import { useState } from 'react';

export const PlpFooter = ({
	seoContent,
	collapsed,
}: {
	seoContent: any;
	collapsed: boolean;
}) => {
	const [height, setHeight] = useState('82.8px');
	const [opened, setOpened] = useState(collapsed);
	return (
		<Box sx={{ padding: '16px', color: getColor('Gray 0') }}>
			<Box
				sx={{
					...getStyle('Tiny-Regular'),
					color: '#333333',
					overflow: 'hidden',
					'& p': {
						margin: '0px',
						marginBlockStart: '0',
						marginBlockEnd: '0',
					},
				}}
			>
				<hr
					style={{
						marginTop: '16px',
						marginBottom: '16px',
						border: '1px solid',
						color: 'whitesmoke',
					}}
				/>
				<Box
					sx={{
						height,
						'& ul': { paddingInlineStart: '0px !important' },
						'& h1': {
							...getStyle('P-SemiBold'),
							marginBottom: '16px !important',
						},
						'& h2': {
							...getStyle('Small-SemiBold'),
							marginBottom: '8px',
						},
						'& p': {
							marginBottom: '24px !important',
						},
						'& *': {
							paddingInlineStart: '0px !important',
							marginLeft: '0px !important',
							padding: '0 !important',
						},
					}}
				>
					<HtmlContentDiv data={seoContent.footer} />
				</Box>
				{seoContent?.schemas?.length > 0 &&
					seoContent?.schemas?.map((data: any, index: number) => {
						return <HtmlContentDiv data={data} key={index} />;
					})}
			</Box>
			{!opened && (
				<Box
					onClick={() => {
						setHeight('initial');
						setOpened(true);
					}}
					sx={{
						...getStyle('Small-SemiBold'),
						color: getColor('Minty 0'),
						margin: '10px 0 24px 0',
						fontFamily: 'Recline',
					}}
				>
					{'See more >'}
				</Box>
			)}
		</Box>
	);
};
